export default __webpack_public_path__ + "static/media/hht2_ep13_timeline_q04_b.18d00b62.png";